export function InterestIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_7882_5898" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_7882_5898"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
export function AlphaIcon(props: { onclick: () => void }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onclick}
    >
      <path
        d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM7.4375 9.95312C7.4375 10.0133 7.38828 10.0625 7.32812 10.0625H6.67188C6.61172 10.0625 6.5625 10.0133 6.5625 9.95312V6.23438C6.5625 6.17422 6.61172 6.125 6.67188 6.125H7.32812C7.38828 6.125 7.4375 6.17422 7.4375 6.23438V9.95312ZM7 5.25C6.82827 5.24649 6.66476 5.17581 6.54455 5.05312C6.42434 4.93044 6.35701 4.76551 6.35701 4.59375C6.35701 4.42199 6.42434 4.25706 6.54455 4.13438C6.66476 4.01169 6.82827 3.94101 7 3.9375C7.17173 3.94101 7.33524 4.01169 7.45545 4.13438C7.57566 4.25706 7.64299 4.42199 7.64299 4.59375C7.64299 4.76551 7.57566 4.93044 7.45545 5.05312C7.33524 5.17581 7.17173 5.24649 7 5.25Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
    </svg>
  );
}
export function LinkIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5779)">
        <path
          d="M9.99968 0.833253C8.18668 0.833253 6.4144 1.37087 4.90695 2.37812C3.3995 3.38536 2.22459 4.817 1.53078 6.49199C0.83698 8.16698 0.655449 10.0101 1.00915 11.7882C1.36284 13.5664 2.23589 15.1998 3.51787 16.4817C4.79985 17.7637 6.43319 18.6368 8.21135 18.9905C9.98951 19.3441 11.8326 19.1626 13.5076 18.4688C15.1826 17.775 16.6142 16.6001 17.6215 15.0926C18.6287 13.5852 19.1663 11.8129 19.1663 9.99992C19.167 8.79595 18.9303 7.60366 18.4699 6.49121C18.0095 5.37876 17.3343 4.36798 16.483 3.51664C15.6316 2.66531 14.6208 1.99012 13.5084 1.52969C12.3959 1.06925 11.2036 0.832596 9.99968 0.833253V0.833253ZM11.1747 13.5333L10.5913 14.1249C9.96588 14.7504 9.11756 15.1018 8.23301 15.1018C7.34847 15.1018 6.50015 14.7504 5.87468 14.1249C5.24921 13.4995 4.89782 12.6511 4.89782 11.7666C4.89782 10.882 5.24921 10.0337 5.87468 9.40825L6.46635 8.82492C6.62576 8.6884 6.83083 8.61706 7.04056 8.62516C7.25029 8.63326 7.44924 8.72021 7.59765 8.86862C7.74606 9.01703 7.833 9.21598 7.8411 9.42571C7.8492 9.63544 7.77787 9.8405 7.64135 9.99992L7.04968 10.5916C6.73694 10.9043 6.56125 11.3285 6.56125 11.7708C6.56125 12.213 6.73694 12.6372 7.04968 12.9499C7.36241 13.2627 7.78657 13.4383 8.22884 13.4383C8.67112 13.4383 9.09528 13.2627 9.40801 12.9499L9.99968 12.3583C10.1591 12.2217 10.3642 12.1504 10.5739 12.1585C10.7836 12.1666 10.9826 12.2535 11.131 12.402C11.2794 12.5504 11.3663 12.7493 11.3744 12.959C11.3825 13.1688 11.3112 13.3738 11.1747 13.5333V13.5333ZM11.4747 9.70825L9.70801 11.4749C9.55109 11.6318 9.33826 11.72 9.11634 11.72C8.89443 11.72 8.6816 11.6318 8.52468 11.4749C8.36776 11.318 8.2796 11.1052 8.2796 10.8833C8.2796 10.6613 8.36776 10.4485 8.52468 10.2916L10.2913 8.52492C10.4483 8.368 10.6611 8.27984 10.883 8.27984C11.1049 8.27984 11.3178 8.368 11.4747 8.52492C11.6316 8.68184 11.7198 8.89467 11.7198 9.11659C11.7198 9.3385 11.6316 9.55133 11.4747 9.70825V9.70825ZM14.1247 10.5916L13.533 11.1749C13.3736 11.3114 13.1685 11.3828 12.9588 11.3747C12.7491 11.3666 12.5501 11.2796 12.4017 11.1312C12.2533 10.9828 12.1664 10.7839 12.1583 10.5741C12.1502 10.3644 12.2215 10.1593 12.358 9.99992L12.9497 9.40825C13.2624 9.09552 13.4381 8.67136 13.4381 8.22909C13.4381 7.78681 13.2624 7.36265 12.9497 7.04992C12.6369 6.73719 12.2128 6.56149 11.7705 6.56149C11.3282 6.56149 10.9041 6.73719 10.5913 7.04992L9.99968 7.64159C9.84026 7.77811 9.6352 7.84945 9.42547 7.84135C9.21574 7.83324 9.01679 7.7463 8.86838 7.59789C8.71996 7.44948 8.63302 7.25053 8.62492 7.0408C8.61682 6.83107 8.68816 6.626 8.82468 6.46659L9.40801 5.87492C10.0335 5.24945 10.8818 4.89807 11.7663 4.89807C12.6509 4.89807 13.4992 5.24945 14.1247 5.87492C14.7501 6.50039 15.1015 7.34871 15.1015 8.23325C15.1015 9.1178 14.7501 9.96612 14.1247 10.5916V10.5916Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5779">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PackageIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5781)">
        <path
          d="M19.5552 4.94693C19.5552 4.92579 19.5552 4.92579 19.5552 4.90465C19.5341 4.86237 19.5341 4.82009 19.5129 4.77781V4.75666C19.4918 4.71438 19.4495 4.6721 19.4284 4.65096L19.4072 4.62982C19.3861 4.60868 19.3438 4.58754 19.3227 4.5664L19.3015 4.54526H19.2804L19.2592 4.52412L10.2744 0.0634222C10.1053 -0.0211407 9.8939 -0.0211407 9.70363 0.0634222L6.68051 1.56441L15.7076 6.19424L15.7287 6.21538C15.7499 6.21538 15.7499 6.23652 15.771 6.23652C15.7922 6.25766 15.7922 6.2788 15.8133 6.29994C15.8133 6.32108 15.8133 6.32108 15.8133 6.34222V6.36336V11.268C15.8133 11.3526 15.771 11.416 15.7076 11.4583L13.8895 12.4096C13.7838 12.473 13.657 12.4308 13.5935 12.325C13.5724 12.3039 13.5724 12.2616 13.5724 12.2193V7.4204L4.43959 2.70601L4.41845 2.68487L0.761103 4.50298L0.739963 4.52412H0.718822L0.697681 4.54526C0.67654 4.5664 0.634259 4.58754 0.613118 4.60868L0.591977 4.62982C0.549696 4.6721 0.528555 4.71438 0.486274 4.75666V4.77781C0.465133 4.82009 0.443992 4.86237 0.443992 4.90465C0.443992 4.92579 0.443992 4.92579 0.443992 4.94693C0.443992 4.98921 0.422852 5.01035 0.422852 5.05264V5.07378V14.9254C0.422852 15.1579 0.549696 15.3905 0.782244 15.4962L9.68249 19.9357C9.80934 19.9991 9.95732 20.0203 10.1053 19.978L10.1476 19.9569C10.1899 19.9569 10.211 19.9357 10.2533 19.9146L19.217 15.475C19.4284 15.3693 19.5764 15.1579 19.5764 14.9042V5.07378V5.05264C19.5552 5.01035 19.5552 4.98921 19.5552 4.94693Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5781">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DolarIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5797)">
        <path
          d="M9.99984 18.3333C5.39734 18.3333 1.6665 14.6025 1.6665 9.99996C1.6665 5.39746 5.39734 1.66663 9.99984 1.66663C14.6023 1.66663 18.3332 5.39746 18.3332 9.99996C18.3332 14.6025 14.6023 18.3333 9.99984 18.3333ZM7.08317 11.6666V13.3333H9.1665V15H10.8332V13.3333H11.6665C12.219 13.3333 12.7489 13.1138 13.1396 12.7231C13.5303 12.3324 13.7498 11.8025 13.7498 11.25C13.7498 10.6974 13.5303 10.1675 13.1396 9.77682C12.7489 9.38612 12.219 9.16662 11.6665 9.16662H8.33317C8.22266 9.16662 8.11668 9.12273 8.03854 9.04459C7.9604 8.96645 7.9165 8.86047 7.9165 8.74996C7.9165 8.63945 7.9604 8.53347 8.03854 8.45533C8.11668 8.37719 8.22266 8.33329 8.33317 8.33329H12.9165V6.66663H10.8332V4.99996H9.1665V6.66663H8.33317C7.78064 6.66663 7.25073 6.88612 6.86003 7.27682C6.46933 7.66752 6.24984 8.19742 6.24984 8.74996C6.24984 9.30249 6.46933 9.8324 6.86003 10.2231C7.25073 10.6138 7.78064 10.8333 8.33317 10.8333H11.6665C11.777 10.8333 11.883 10.8772 11.9611 10.9553C12.0393 11.0335 12.0832 11.1395 12.0832 11.25C12.0832 11.3605 12.0393 11.4664 11.9611 11.5446C11.883 11.6227 11.777 11.6666 11.6665 11.6666H7.08317Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5797">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FlatIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5799)">
        <path
          d="M1.6665 2.5H17.6148C17.6879 2.49988 17.7597 2.51896 17.823 2.55532C17.8863 2.59169 17.939 2.64406 17.9757 2.7072C18.0124 2.77034 18.0319 2.84201 18.0322 2.91505C18.0325 2.98809 18.0136 3.05991 17.9773 3.12333L14.9998 8.33333L17.9773 13.5433C18.0136 13.6068 18.0325 13.6786 18.0322 13.7516C18.0319 13.8247 18.0124 13.8963 17.9757 13.9595C17.939 14.0226 17.8863 14.075 17.823 14.1113C17.7597 14.1477 17.6879 14.1668 17.6148 14.1667H3.33317V18.3333H1.6665V2.5Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5799">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ExpectedEffortRequiredIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5799)">
        <path
          d="M1.6665 2.5H17.6148C17.6879 2.49988 17.7597 2.51896 17.823 2.55532C17.8863 2.59169 17.939 2.64406 17.9757 2.7072C18.0124 2.77034 18.0319 2.84201 18.0322 2.91505C18.0325 2.98809 18.0136 3.05991 17.9773 3.12333L14.9998 8.33333L17.9773 13.5433C18.0136 13.6068 18.0325 13.6786 18.0322 13.7516C18.0319 13.8247 18.0124 13.8963 17.9757 13.9595C17.939 14.0226 17.8863 14.075 17.823 14.1113C17.7597 14.1477 17.6879 14.1668 17.6148 14.1667H3.33317V18.3333H1.6665V2.5Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5799">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DeadlineIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.849609 9.99797C0.849609 4.93536 4.95367 0.831299 10.0163 0.831299C15.0789 0.831299 19.1829 4.93536 19.1829 9.99797V10.8313H17.0281L10.8496 17.0098V19.1646H10.0163C4.95367 19.1646 0.849609 15.0606 0.849609 9.99797ZM11.6813 11.6648V4.99817H10.0146V9.99817H5.01465V11.6648H11.6813Z"
          fill="#080F6C"
        />
        <circle cx="12.7214" cy="17.7067" r="1.04167" fill="#080F6C" />
        <circle cx="17.7214" cy="12.7067" r="1.04167" fill="#080F6C" />
        <circle cx="15.8333" cy="15.8333" r="0.833333" fill="#080F6C" />
      </g>
    </svg>
  );
}

export function CollaboratorIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5796)">
        <path
          d="M9.99984 9.16662C11.1049 9.16662 12.1647 9.60561 12.9461 10.387C13.7275 11.1684 14.1665 12.2282 14.1665 13.3333V18.3333H5.83317V13.3333C5.83317 12.2282 6.27216 11.1684 7.05356 10.387C7.83496 9.60561 8.89477 9.16662 9.99984 9.16662ZM4.4065 11.6716C4.27389 12.1189 4.19554 12.5806 4.17317 13.0466L4.1665 13.3333V18.3333H1.6665V14.5833C1.66634 13.8646 1.93153 13.1712 2.4112 12.636C2.89087 12.1008 3.55125 11.7615 4.26567 11.6833L4.40734 11.6716H4.4065ZM15.5932 11.6716C16.3348 11.7168 17.0312 12.0433 17.5403 12.5843C18.0495 13.1254 18.3331 13.8403 18.3332 14.5833V18.3333H15.8332V13.3333C15.8332 12.7558 15.7498 12.1983 15.5932 11.6716ZM4.58317 6.66663C5.1357 6.66663 5.66561 6.88612 6.05631 7.27682C6.44701 7.66752 6.6665 8.19742 6.6665 8.74996C6.6665 9.30249 6.44701 9.8324 6.05631 10.2231C5.66561 10.6138 5.1357 10.8333 4.58317 10.8333C4.03064 10.8333 3.50073 10.6138 3.11003 10.2231C2.71933 9.8324 2.49984 9.30249 2.49984 8.74996C2.49984 8.19742 2.71933 7.66752 3.11003 7.27682C3.50073 6.88612 4.03064 6.66663 4.58317 6.66663ZM15.4165 6.66663C15.969 6.66663 16.4989 6.88612 16.8896 7.27682C17.2803 7.66752 17.4998 8.19742 17.4998 8.74996C17.4998 9.30249 17.2803 9.8324 16.8896 10.2231C16.4989 10.6138 15.969 10.8333 15.4165 10.8333C14.864 10.8333 14.3341 10.6138 13.9434 10.2231C13.5527 9.8324 13.3332 9.30249 13.3332 8.74996C13.3332 8.19742 13.5527 7.66752 13.9434 7.27682C14.3341 6.88612 14.864 6.66663 15.4165 6.66663ZM9.99984 1.66663C10.8839 1.66663 11.7317 2.01782 12.3569 2.64294C12.982 3.26806 13.3332 4.1159 13.3332 4.99996C13.3332 5.88401 12.982 6.73186 12.3569 7.35698C11.7317 7.9821 10.8839 8.33329 9.99984 8.33329C9.11578 8.33329 8.26793 7.9821 7.64281 7.35698C7.01769 6.73186 6.6665 5.88401 6.6665 4.99996C6.6665 4.1159 7.01769 3.26806 7.64281 2.64294C8.26793 2.01782 9.11578 1.66663 9.99984 1.66663Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5796">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TypeOfTaskIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56">
        <path
          d="M17.5 9.25703V4.16536C17.5 3.72334 17.3244 3.29941 17.0118 2.98685C16.6993 2.67429 16.2754 2.4987 15.8333 2.4987H12.35C12 1.53203 11.0833 0.832031 10 0.832031C8.91667 0.832031 8 1.53203 7.65 2.4987H4.16667C3.25 2.4987 2.5 3.2487 2.5 4.16536V15.832C2.5 16.2741 2.67559 16.698 2.98816 17.0105C3.30072 17.3231 3.72464 17.4987 4.16667 17.4987H9.25833C10.3083 18.532 11.7417 19.1654 13.3333 19.1654C16.5583 19.1654 19.1667 16.557 19.1667 13.332C19.1667 11.7404 18.5333 10.307 17.5 9.25703ZM10 2.4987C10.4583 2.4987 10.8333 2.8737 10.8333 3.33203C10.8333 3.79036 10.4583 4.16536 10 4.16536C9.54167 4.16536 9.16667 3.79036 9.16667 3.33203C9.16667 2.8737 9.54167 2.4987 10 2.4987ZM5 5.83203H15V7.4987H5V5.83203ZM7.56667 14.1654H5V12.4987H7.56667C7.525 12.7737 7.5 13.0487 7.5 13.332C7.5 13.6154 7.525 13.8904 7.56667 14.1654ZM5 10.832V9.16537H9.25833C8.75 9.64037 8.36667 10.207 8.06667 10.832H5ZM13.3333 17.4987C11.0333 17.4987 9.16667 15.632 9.16667 13.332C9.16667 11.032 11.0333 9.16537 13.3333 9.16537C15.6333 9.16537 17.5 11.032 17.5 13.332C17.5 15.632 15.6333 17.4987 13.3333 17.4987ZM13.75 13.5404L16.1333 14.9487L15.5083 15.9654L12.5 14.1654V9.9987H13.75V13.5404Z"
          fill="#080F6C"
        />
      </g>
    </svg>
  );
}

export function TaskIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56">
        <path
          d="M13.492 1.66675H6.50866C3.47533 1.66675 1.66699 3.47508 1.66699 6.50841V13.4917C1.66699 16.5251 3.47533 18.3334 6.50866 18.3334H13.492C16.5253 18.3334 18.3337 16.5251 18.3337 13.4917V6.50841C18.3337 3.47508 16.5253 1.66675 13.492 1.66675ZM8.30866 12.4167L6.43366 14.2917C6.30866 14.4167 6.15033 14.4751 5.99199 14.4751C5.83366 14.4751 5.66699 14.4167 5.55033 14.2917L4.92533 13.6667C4.67533 13.4251 4.67533 13.0251 4.92533 12.7834C5.16699 12.5417 5.55866 12.5417 5.80866 12.7834L5.99199 12.9667L7.42533 11.5334C7.66699 11.2917 8.05866 11.2917 8.30866 11.5334C8.55033 11.7751 8.55033 12.1751 8.30866 12.4167ZM8.30866 6.58342L6.43366 8.45841C6.30866 8.58341 6.15033 8.64175 5.99199 8.64175C5.83366 8.64175 5.66699 8.58341 5.55033 8.45841L4.92533 7.83341C4.67533 7.59175 4.67533 7.19175 4.92533 6.95008C5.16699 6.70842 5.55866 6.70842 5.80866 6.95008L5.99199 7.13342L7.42533 5.70008C7.66699 5.45842 8.05866 5.45842 8.30866 5.70008C8.55033 5.94175 8.55033 6.34175 8.30866 6.58342ZM14.6337 13.8501H10.2587C9.91699 13.8501 9.63366 13.5667 9.63366 13.2251C9.63366 12.8834 9.91699 12.6001 10.2587 12.6001H14.6337C14.9837 12.6001 15.2587 12.8834 15.2587 13.2251C15.2587 13.5667 14.9837 13.8501 14.6337 13.8501ZM14.6337 8.01675H10.2587C9.91699 8.01675 9.63366 7.73342 9.63366 7.39175C9.63366 7.05008 9.91699 6.76675 10.2587 6.76675H14.6337C14.9837 6.76675 15.2587 7.05008 15.2587 7.39175C15.2587 7.73342 14.9837 8.01675 14.6337 8.01675Z"
          fill="#080F6C"
        />
      </g>
    </svg>
  );
}

export function ExperienceIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.56" clipPath="url(#clip0_7882_5785)">
        <path
          d="M2.3334 4.33336L5.8334 6.66669L9.32173 1.78336C9.39882 1.67534 9.50059 1.58728 9.61858 1.52653C9.73657 1.46578 9.86736 1.43408 10.0001 1.43408C10.1328 1.43408 10.2636 1.46578 10.3816 1.52653C10.4995 1.58728 10.6013 1.67534 10.6784 1.78336L14.1667 6.66669L17.6667 4.33336C17.7992 4.24523 17.9541 4.19687 18.1132 4.19397C18.2723 4.19108 18.4288 4.23379 18.5644 4.31705C18.7 4.4003 18.8089 4.52063 18.8783 4.66381C18.9476 4.80699 18.9746 4.96703 18.9559 5.12503L17.5867 16.7642C17.5629 16.9669 17.4654 17.1538 17.3129 17.2894C17.1603 17.4251 16.9633 17.5 16.7592 17.5H3.2409C3.03679 17.5 2.83979 17.4251 2.68726 17.2894C2.53473 17.1538 2.43728 16.9669 2.4134 16.7642L1.04423 5.1242C1.02573 4.96626 1.0528 4.80634 1.12225 4.66329C1.1917 4.52025 1.30062 4.40006 1.43616 4.31691C1.5717 4.23377 1.7282 4.19113 1.88718 4.19405C2.04617 4.19696 2.201 4.2453 2.3334 4.33336V4.33336ZM10.0001 12.5C10.4421 12.5 10.866 12.3244 11.1786 12.0119C11.4911 11.6993 11.6667 11.2754 11.6667 10.8334C11.6667 10.3913 11.4911 9.96741 11.1786 9.65485C10.866 9.34229 10.4421 9.16669 10.0001 9.16669C9.55804 9.16669 9.13412 9.34229 8.82156 9.65485C8.509 9.96741 8.3334 10.3913 8.3334 10.8334C8.3334 11.2754 8.509 11.6993 8.82156 12.0119C9.13412 12.3244 9.55804 12.5 10.0001 12.5Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5785">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function Background() {
  return (
    <svg
      width="100%"
      viewBox="0 0 1176 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6" filter="url(#filter0_f_7882_5879)">
        <ellipse
          cx="588"
          cy="68"
          rx="544"
          ry="24"
          fill="url(#paint0_linear_7882_5879)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_7882_5879"
          x="0"
          y="0"
          width="1176"
          height="136"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="22"
            result="effect1_foregroundBlur_7882_5879"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7882_5879"
          x1="136.178"
          y1="44"
          x2="428.03"
          y2="550.746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C58AFF" />
          <stop offset="0.424221" stopColor="#00ADFB" />
          <stop offset="0.744792" stopColor="#00D5C9" />
          <stop offset="1" stopColor="#00DE8C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function GitIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="11" fill="#54A258" fillOpacity="0.15" />
      <g clipPath="url(#clip0_7882_5882)">
        <path
          d="M10.9991 4.14587C7.13425 4.14587 4 7.29237 4 11.1739C4 14.2784 6.0055 16.9121 8.788 17.8422C9.138 17.907 9.26575 17.69 9.26575 17.5036C9.26575 17.3365 9.25962 16.8946 9.25612 16.3084C7.30925 16.7327 6.898 15.366 6.898 15.366C6.58037 14.554 6.121 14.3379 6.121 14.3379C5.48487 13.9021 6.16825 13.9109 6.16825 13.9109C6.87087 13.9607 7.24013 14.6354 7.24013 14.6354C7.86488 15.709 8.879 15.3992 9.278 15.219C9.341 14.7649 9.52212 14.4551 9.7225 14.2792C8.1685 14.1016 6.534 13.4987 6.534 10.8064C6.534 10.039 6.807 9.41162 7.255 8.91987C7.18237 8.74225 6.94263 8.02737 7.32325 7.0605C7.32325 7.0605 7.91125 6.8715 9.24825 7.78062C9.8065 7.62487 10.405 7.547 11.0009 7.54437C11.595 7.54787 12.1944 7.62487 12.7535 7.7815C14.0896 6.87237 14.6768 7.06137 14.6768 7.06137C15.0582 8.02912 14.8185 8.74312 14.7467 8.92075C15.1956 9.4125 15.466 10.0399 15.466 10.8072C15.466 13.5066 13.8298 14.1007 12.2705 14.2749C12.5216 14.4919 12.7456 14.9206 12.7456 15.576C12.7456 16.5157 12.7369 17.2735 12.7369 17.5036C12.7369 17.6917 12.8629 17.9105 13.2181 17.8414C15.9963 16.9104 18 14.2775 18 11.1739C18 7.29237 14.8658 4.14587 10.9991 4.14587Z"
          fill="#54A258"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5882">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GitBookIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="11" fill="#6466D9" fillOpacity="0.15" />
      <g clipPath="url(#clip0_7882_5889)">
        <path
          d="M10.2018 15.0008C10.4518 15.0008 10.6767 15.2084 10.6767 15.494C10.6767 15.7537 10.4768 15.9872 10.2018 15.9872C9.95178 15.9872 9.72695 15.7796 9.72695 15.494C9.72695 15.2084 9.95203 15.0008 10.2018 15.0008ZM17.5503 11.9894C17.3003 11.9894 17.0755 11.7819 17.0755 11.4963C17.0755 11.2368 17.2753 11.0031 17.5503 11.0031C17.8003 11.0031 18.0252 11.2107 18.0252 11.4963C18.0252 11.756 17.8001 11.9894 17.5503 11.9894ZM17.5503 9.99046C16.7506 9.99046 16.1005 10.6654 16.1005 11.496C16.1005 11.6517 16.1255 11.8077 16.1756 11.9634L11.4016 14.6112C11.1266 14.1958 10.6767 13.9621 10.2018 13.9621C9.65184 13.9621 9.15203 14.2996 8.902 14.7927L4.60279 12.4563C4.15288 12.1968 3.80304 11.4439 3.85294 10.717C3.8779 10.3535 4.00291 10.0679 4.17784 9.96413C4.30285 9.88615 4.42787 9.91223 4.60279 9.98995C5.75264 10.613 9.50187 12.6639 9.65184 12.7419C9.90187 12.8456 10.0266 12.8975 10.4516 12.69L18.1499 8.53628C18.275 8.48438 18.4 8.38059 18.4 8.19881C18.4 7.96514 18.1749 7.86134 18.1749 7.86134C17.725 7.65375 17.0503 7.31628 16.4002 7.00464C15.0006 6.3297 13.4008 5.55097 12.7009 5.16134C12.101 4.82388 11.6012 5.10945 11.5261 5.16134C8.35227 6.82337 3.9782 9.05603 3.72817 9.21172C3.30322 9.47147 3.02848 10.0165 3.00328 10.6915C2.95337 11.7558 3.47814 12.8722 4.22799 13.2616L8.77698 15.7019C8.87704 16.4287 9.50187 16.9998 10.2016 16.9998C11.0013 16.9998 11.6264 16.3507 11.6514 15.5201L16.6503 12.7163C16.9003 12.9239 17.2252 13.0277 17.5501 13.0277C18.3498 13.0277 18.9999 12.3527 18.9999 11.5221C18.9999 10.6915 18.3501 9.99046 17.5501 9.99046H17.5503Z"
          fill="#6466D9"
        />
      </g>
      <defs>
        <clipPath id="clip0_7882_5889">
          <rect
            width="16"
            height="12"
            fill="white"
            transform="translate(3 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PendingIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 14.6666C10.4111 14.6666 9.62511 14.3417 8.97533 13.692C8.32511 13.0417 8 12.2555 8 11.3333C8 10.4111 8.32511 9.62485 8.97533 8.97463C9.62511 8.32485 10.4111 7.99996 11.3333 7.99996C12.2556 7.99996 13.0418 8.32485 13.692 8.97463C14.3418 9.62485 14.6667 10.4111 14.6667 11.3333C14.6667 12.2555 14.3418 13.0417 13.692 13.692C13.0418 14.3417 12.2556 14.6666 11.3333 14.6666ZM12.45 12.9166L12.9167 12.45L11.6667 11.2V9.33329H11V11.4666L12.45 12.9166ZM3.33333 14C2.96667 14 2.65267 13.8695 2.39133 13.6086C2.13044 13.3473 2 13.0333 2 12.6666V3.33329C2 2.96663 2.13044 2.65263 2.39133 2.39129C2.65267 2.1304 2.96667 1.99996 3.33333 1.99996H6.11667C6.23889 1.61107 6.47778 1.29151 6.83333 1.04129C7.18889 0.791515 7.57778 0.666626 8 0.666626C8.44444 0.666626 8.84178 0.791515 9.192 1.04129C9.54178 1.29151 9.77778 1.61107 9.9 1.99996H12.6667C13.0333 1.99996 13.3473 2.1304 13.6087 2.39129C13.8696 2.65263 14 2.96663 14 3.33329V7.49996C13.8 7.35552 13.5889 7.23329 13.3667 7.13329C13.1444 7.03329 12.9111 6.9444 12.6667 6.86663V3.33329H11.3333V5.33329H4.66667V3.33329H3.33333V12.6666H6.86667C6.94444 12.9111 7.03333 13.1444 7.13333 13.3666C7.23333 13.5888 7.35556 13.8 7.5 14H3.33333ZM8 3.33329C8.18889 3.33329 8.34733 3.26929 8.47533 3.14129C8.60289 3.01374 8.66667 2.85552 8.66667 2.66663C8.66667 2.47774 8.60289 2.31929 8.47533 2.19129C8.34733 2.06374 8.18889 1.99996 8 1.99996C7.81111 1.99996 7.65289 2.06374 7.52533 2.19129C7.39733 2.31929 7.33333 2.47774 7.33333 2.66663C7.33333 2.85552 7.39733 3.01374 7.52533 3.14129C7.65289 3.26929 7.81111 3.33329 8 3.33329Z"
        fill="#080F6C"
      />
    </svg>
  );
}

export function HTMLIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.08008 0H6.1582V1.06875H7.15195V0H8.23008V3.23438H7.15195V2.15625H6.16758V3.23438H5.08008V0ZM9.65508 1.07812H8.70352V0H11.6895V1.07812H10.7332V3.23438H9.65508V1.07812ZM12.1629 0H13.2926L13.9863 1.13906L14.6801 0H15.8098V3.23438H14.7316V1.63125L13.977 2.79375L13.2223 1.63125V3.23438H12.1629V0ZM16.3441 0H17.4223V2.16563H18.9504V3.23438H16.3441V0Z"
        fill="#080F6C"
      />
      <path
        d="M5.04297 22.0781L3.49609 4.71564H20.5023L18.9555 22.0688L11.9852 24"
        fill="#FF4C1E"
      />
      <path
        d="M12 22.5234V6.14062H18.9516L17.625 20.9531L12 22.5234Z"
        fill="#FF651E"
      />
      <path
        d="M6.65625 8.26416H12L12.7946 9.32822L12 10.3923H8.99063L9.1875 12.572H12L12.7946 13.6758L12 14.6954H7.2375L6.65625 8.26416ZM7.33125 15.7642H9.46875L9.61875 17.4657L12 18.1032L12.8966 19.1654L12 20.3251L7.63125 19.1063L7.33125 15.7642Z"
        fill="#EBEBEB"
      />
      <path
        d="M17.3246 8.26416H11.9902V10.3923H17.1277L17.3246 8.26416ZM16.9355 12.572H11.9902V14.7001H14.6152L14.3668 17.4657L11.9902 18.1032V20.3157L16.3496 19.1063L16.9355 12.572Z"
        fill="white"
      />
    </svg>
  );
}

export function JavascriptIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7886_6275)">
        <path d="M0 0H24V24H0V0Z" fill="#FFDF00" />
        <path
          d="M16.121 18.7502C16.6045 19.5396 17.2334 20.1197 18.3458 20.1197C19.2803 20.1197 19.8772 19.6527 19.8772 19.0073C19.8772 18.234 19.2639 17.9601 18.2353 17.5102L17.6715 17.2683C16.0441 16.5749 14.963 15.7063 14.963 13.8702C14.963 12.1787 16.2517 10.8911 18.2658 10.8911C19.6997 10.8911 20.7306 11.3901 21.4734 12.6968L19.7173 13.8245C19.3306 13.1311 18.9134 12.858 18.2658 12.858C17.6053 12.858 17.1866 13.2771 17.1866 13.8245C17.1866 14.5011 17.6056 14.7749 18.5732 15.194L19.137 15.4355C21.0532 16.2572 22.1351 17.0949 22.1351 18.9784C22.1351 21.0088 20.54 22.1212 18.398 22.1212C16.3035 22.1212 14.9503 21.1231 14.2882 19.8149L16.121 18.7502ZM8.15417 18.9456C8.50845 19.5742 8.83077 20.1057 9.60561 20.1057C10.3466 20.1057 10.814 19.8157 10.814 18.6885V11.0199H13.0693V18.719C13.0693 21.0542 11.7001 22.1171 9.70161 22.1171C7.89589 22.1171 6.8502 21.1826 6.31836 20.0571L8.15417 18.9456Z"
          fill="#080F6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7886_6275">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PythonIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7886_6281)">
        <path
          d="M11.8585 0.00019618C10.8796 0.00474306 9.94487 0.0882274 9.1224 0.233774C6.69948 0.661837 6.25956 1.55776 6.25956 3.21006V5.39223H11.9852V6.11959H6.25956H4.11076C2.44675 6.11959 0.989639 7.11976 0.53392 9.02246C0.00821725 11.2034 -0.0150796 12.5643 0.53392 14.8416C0.940936 16.5366 1.91289 17.7444 3.5769 17.7444H5.54551V15.1284C5.54551 13.2386 7.18065 11.5716 9.1224 11.5716H14.8414C16.4334 11.5716 17.7042 10.2609 17.7042 8.66209V3.21006C17.7042 1.6584 16.3952 0.492759 14.8414 0.233774C13.8578 0.0700399 12.8372 -0.0043507 11.8585 0.00019618ZM8.76203 1.75529C9.35345 1.75529 9.8364 2.24617 9.8364 2.84968C9.8364 3.45109 9.35345 3.93742 8.76203 3.93742C8.1685 3.93742 7.68765 3.45109 7.68765 2.84968C7.68765 2.24612 8.1685 1.75529 8.76203 1.75529Z"
          fill="url(#paint0_linear_7886_6281)"
        />
        <path
          d="M18.4184 6.1196V8.6621C18.4184 10.6333 16.7472 12.2923 14.8416 12.2923H9.12261C7.55609 12.2923 6.25977 13.6331 6.25977 15.2019V20.6539C6.25977 22.2056 7.60906 23.1183 9.12261 23.5634C10.935 24.0964 12.6731 24.1927 14.8416 23.5634C16.283 23.1461 17.7044 22.3062 17.7044 20.6539V18.4717H11.9854V17.7443H17.7044H20.5672C22.2313 17.7443 22.8514 16.5836 23.4301 14.8415C24.0279 13.048 24.0024 11.3232 23.4301 9.02238C23.0188 7.36582 22.2334 6.11951 20.5672 6.11951H18.4184V6.1196ZM15.202 19.9265C15.7955 19.9265 16.2763 20.4129 16.2763 21.0143C16.2763 21.6178 15.7955 22.1087 15.202 22.1087C14.6105 22.1087 14.1276 21.6178 14.1276 21.0143C14.1275 20.4129 14.6105 19.9265 15.202 19.9265Z"
          fill="url(#paint1_linear_7886_6281)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7886_6281"
          x1="-0.430302"
          y1="0.682528"
          x2="12.7754"
          y2="11.9442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A9FD4" />
          <stop offset="1" stopColor="#306998" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7886_6281"
          x1="17.7443"
          y1="18.9446"
          x2="13.0086"
          y2="12.3034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD43B" />
          <stop offset="1" stopColor="#FFE873" />
        </linearGradient>
        <clipPath id="clip0_7886_6281">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TypescriptIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7886_6288)">
        <path
          d="M2.34375 0H21.6562C22.9507 0 24 1.04934 24 2.34375V21.6562C24 22.9507 22.9507 24 21.6562 24H2.34375C1.04934 24 0 22.9507 0 21.6562V2.34375C0 1.04934 1.04934 0 2.34375 0Z"
          fill="#3178C6"
        />
        <path
          d="M2.34375 0H21.6562C22.9507 0 24 1.04934 24 2.34375V21.6562C24 22.9507 22.9507 24 21.6562 24H2.34375C1.04934 24 0 22.9507 0 21.6562V2.34375C0 1.04934 1.04934 0 2.34375 0Z"
          fill="#3178C6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8565 19.098V21.4446C15.238 21.6402 15.6892 21.7868 16.21 21.8846C16.7309 21.9824 17.2799 22.0312 17.857 22.0312C18.8516 22.0312 19.9405 21.889 20.7915 21.3383C21.6382 20.7902 22.0312 19.8786 22.0312 18.8927C22.0312 18.1597 21.8039 17.4544 21.2903 16.9201C20.5202 16.119 19.438 15.7941 18.4658 15.3178C17.9789 15.0792 17.3068 14.7088 17.3068 14.0821C17.3068 13.9208 17.3483 13.7754 17.4315 13.6459C17.7658 13.125 18.5084 13.0189 19.0748 13.0189C19.7178 13.0189 20.3962 13.1628 20.9932 13.4295C21.201 13.5224 21.393 13.6299 21.5691 13.7522V11.5596C21.2121 11.4227 20.822 11.3212 20.399 11.2552C19.9759 11.1892 19.4905 11.1562 18.9427 11.1562C18.3852 11.1562 17.857 11.2162 17.3581 11.3359C16.8593 11.4557 16.4204 11.6427 16.0413 11.8969C15.6622 12.1511 15.3627 12.475 15.1426 12.8685C14.9226 13.2621 14.8125 13.7326 14.8125 14.2801C14.8125 14.9792 15.0142 15.5757 15.4177 16.0695C15.8212 16.5632 16.4338 16.9812 17.2554 17.3234C17.8082 17.5494 18.3829 17.7725 18.8804 18.108C19.2251 18.3405 19.5369 18.6648 19.5369 19.1053C19.5369 19.425 19.3562 19.6961 19.0931 19.8643C18.7039 20.1131 18.2055 20.1686 17.7542 20.1686C17.2456 20.1686 16.7419 20.0794 16.243 19.901C15.7442 19.7226 15.282 19.4549 14.8565 19.098ZM10.9116 13.3163H13.9219V11.3906H5.53125V13.3163H8.52684V21.8906H10.9116V13.3163Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7886_6288">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Css3Icon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5012 4.71655L18.9522 22.0696L11.9892 24L5.04544 22.0723L3.49805 4.71655H20.5012Z"
        fill="#004CE8"
      />
      <path
        d="M17.6264 20.9647L18.9502 6.13574H12V22.5246L17.6264 20.9647Z"
        fill="#0065F4"
      />
      <path
        d="M7.04492 12.5729L7.2357 14.7015H11.9991L12.9147 13.6372L11.9991 12.5729H7.04492Z"
        fill="#EBEBEB"
      />
      <path
        d="M11.9997 8.26428H11.9923H6.66211L6.85561 10.3929H11.9997L12.9153 9.32858L11.9997 8.26428Z"
        fill="#EBEBEB"
      />
      <path
        d="M12.0004 20.3157L12.916 19.1869L12.0004 18.1011L11.991 18.1035L9.62038 17.4634L9.46883 15.7657H8.31688H7.33203L7.63025 19.108L11.9906 20.3184L12.0004 20.3157Z"
        fill="#EBEBEB"
      />
      <path
        d="M7.5 0H10.0781V1.07812H8.57812V2.15625H10.0781V3.23438H7.5V0Z"
        fill="#080F6C"
      />
      <path
        d="M10.5938 0H13.1719V0.9375H11.6719V1.125H13.1719V3.28125H10.5938V2.29688H12.0938V2.10938H10.5938V0Z"
        fill="#080F6C"
      />
      <path
        d="M13.6875 0H16.2656V0.9375H14.7656V1.125H16.2656V3.28125H13.6875V2.29688H15.1875V2.10938H13.6875V0Z"
        fill="#080F6C"
      />
      <path
        d="M14.6133 14.7013L14.3663 17.4619L11.9922 18.1027V20.3173L16.356 19.1078L16.388 18.7482L16.8882 13.1443L16.9401 12.5727L17.3244 8.26428H11.9922V10.3929H14.9916L14.7979 12.5727H11.9922V14.7013H14.6133Z"
        fill="white"
      />
    </svg>
  );
}

export function AkarIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1627 4.66651H32.8376C37.092 4.66644 40.5216 4.66639 43.2189 5.02916C46.0192 5.4058 48.3774 6.2116 50.2495 8.0853C52.1222 9.95717 52.9276 12.3148 53.3042 15.1145C53.667 17.8118 53.6669 21.2413 53.6668 25.4958V25.8372C53.6669 30.0917 53.667 33.5212 53.3042 36.2185C52.9276 39.0182 52.1222 41.3758 50.2495 43.2477C48.3774 45.1214 46.0192 45.9272 43.2189 46.3039C40.5216 46.6666 37.092 46.6666 32.8376 46.6665H32.6668C31.3782 46.6665 30.3335 45.6218 30.3335 44.3332C30.3335 43.0445 31.3782 41.9998 32.6668 41.9998C37.1323 41.9998 40.2469 41.9949 42.5968 41.6788C44.8796 41.3718 46.088 40.8103 46.9482 39.9493C47.8092 39.0891 48.3721 37.8793 48.6792 35.5965C48.9952 33.2466 49.0002 30.132 49.0002 25.6665C49.0002 21.201 48.9952 18.0864 48.6792 15.7365C48.3721 13.4537 47.8106 12.2454 46.9496 11.3851C46.0894 10.5242 44.8796 9.96121 42.5968 9.65419C40.2469 9.33813 37.1323 9.33317 32.6668 9.33317H23.3335C18.868 9.33317 15.7534 9.33813 13.4035 9.65419C11.1207 9.96121 9.91235 10.5228 9.05212 11.3837C8.19115 12.244 7.62821 13.4537 7.32118 15.7365C7.00513 18.0864 7.00017 21.201 7.00017 25.6665C7.00017 30.132 7.00513 33.2466 7.32118 35.5965C7.62821 37.8793 8.18974 39.0877 9.05071 39.9479L9.05268 39.9499C10.0104 40.9091 11.3993 41.4967 14.227 41.7729C15.5096 41.8982 16.4477 43.0395 16.3224 44.322C16.1971 45.6046 15.0559 46.5427 13.7733 46.4175C10.5349 46.1011 7.84082 45.3402 5.7514 43.2482C3.87833 41.3763 3.07273 39.0184 2.69615 36.2185C2.33338 33.5213 2.33343 30.0917 2.3335 25.8373V25.4957C2.33343 21.2413 2.33338 17.8118 2.69615 15.1145C3.07274 12.3145 3.87839 9.95658 5.75158 8.08459C7.62357 6.21139 9.98147 5.40575 12.7815 5.02916C15.4788 4.66639 18.9083 4.66644 23.1627 4.66651Z"
        fill="#7E00FD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3764 38.5091C16.6598 38.6248 17.6065 39.759 17.4908 41.0424L17.3926 42.1324C17.1686 44.5874 17.0245 46.2132 17.0546 47.3331C17.0573 47.4327 17.0613 47.5224 17.0663 47.603C17.1837 47.5638 17.3181 47.5154 17.4712 47.4559C18.633 47.0045 20.2449 46.1714 22.6297 44.9337C25.646 43.3685 29.2242 41.9997 32.6669 41.9997C33.9556 41.9997 35.0003 43.0443 35.0003 44.333C35.0003 45.6217 33.9556 46.6663 32.6669 46.6663C30.3418 46.6663 27.5638 47.6309 24.7795 49.0757L24.6366 49.1498C22.4234 50.2986 20.5872 51.2517 19.1615 51.8057C18.4286 52.0905 17.6509 52.3331 16.8836 52.4055C16.0859 52.4808 15.1335 52.3853 14.2625 51.7999C12.6236 50.6996 12.4242 48.7463 12.3896 47.4585C12.3511 46.0251 12.5255 44.1154 12.7321 41.8526L12.843 40.6235C12.9587 39.3401 14.0929 38.3934 15.3764 38.5091Z"
        fill="#7E00FD"
      />
      <path
        d="M26.6775 19.0283C26.3492 19.288 25.9511 19.7896 25.4166 20.8479C24.8357 21.9982 23.4322 22.4597 22.2819 21.8788C21.1316 21.2978 20.6701 19.8944 21.2511 18.7441C21.8832 17.4924 22.6518 16.2627 23.7819 15.3686C24.9933 14.4101 26.4054 14 28.0005 14C32.3572 14 35.0005 17.5191 35.0005 20.9487C35.0005 21.7105 34.9065 22.5061 34.5634 23.2803C34.2103 24.0771 33.6822 24.6523 33.1327 25.1063C32.6232 25.5274 32.011 25.9096 31.4291 26.2676C31.3275 26.3302 31.224 26.3936 31.1184 26.4584L31.118 26.4586C30.8702 26.6105 30.6103 26.7698 30.3338 26.9425V28C30.3338 29.2887 29.2892 30.3333 28.0005 30.3333C26.7118 30.3333 25.6672 29.2887 25.6672 28V24.4102L26.7161 23.7186C27.4851 23.2116 28.1524 22.8027 28.6923 22.4719L28.6923 22.4718C28.7939 22.4096 28.8909 22.3501 28.9833 22.2933C29.6046 21.9109 29.9403 21.6906 30.1599 21.509C30.2399 21.4429 30.2808 21.4008 30.2993 21.3794C30.31 21.3379 30.3338 21.2143 30.3338 20.9487C30.3338 19.7629 29.4585 18.6667 28.0005 18.6667C27.2623 18.6667 26.9243 18.8329 26.6775 19.0283Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
      <path
        d="M28.0005 31.5C29.2892 31.5 30.3338 32.5447 30.3338 33.8333V35C30.3338 36.2887 29.2892 37.3333 28.0005 37.3333C26.7118 37.3333 25.6672 36.2887 25.6672 35V33.8333C25.6672 32.5447 26.7118 31.5 28.0005 31.5Z"
        fill="#292E73"
        fillOpacity="0.42"
      />
    </svg>
  );
}
